var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistration1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "_x38_2_Online_Registration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m285.177 51.023h8.346c3.188 0 5.774-2.586 5.774-5.774s-2.586-5.774-5.774-5.774h-8.346c-3.188 0-5.774 2.586-5.774 5.774s2.586 5.774 5.774 5.774z",
    fill: "#D00000",
    "data-original": "#D00000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.233 51.023h91.41c3.188 0 5.774-2.586 5.774-5.774s-2.586-5.774-5.774-5.774h-91.41c-3.188 0-5.774 2.586-5.774 5.774s2.586 5.774 5.774 5.774z",
    fill: "#D00000",
    "data-original": "#D00000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.902 435.451c-11.113 0-20.15 9.038-20.15 20.143 0 11.113 9.038 20.15 20.15 20.15 11.083 0 20.102-9.038 20.102-20.15 0-11.105-9.019-20.143-20.102-20.143zm0 28.744c-4.744 0-8.602-3.857-8.602-8.602 0-4.737 3.857-8.594 8.602-8.594 4.714 0 8.553 3.857 8.553 8.594 0 4.745-3.838 8.602-8.553 8.602z",
    fill: "#D00000",
    "data-original": "#D00000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.846 92.098c-18.282 0-33.154 14.902-33.154 33.218 0 18.286 14.872 33.158 33.154 33.158 18.32 0 33.222-14.872 33.222-33.158 0-18.316-14.903-33.218-33.222-33.218zm0 54.827c-11.914 0-21.605-9.692-21.605-21.609 0-11.947 9.692-21.669 21.605-21.669 11.951 0 21.673 9.722 21.673 21.669 0 11.917-9.722 21.609-21.673 21.609z",
    fill: "#D00000",
    "data-original": "#D00000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.143 236.519c0 3.188 2.586 5.774 5.774 5.774h103.921.154c3.188 0 5.774-2.586 5.774-5.774 0-.474-.056-.932-.165-1.376-.594-38.759-26.286-70.06-57.782-70.06-31.804 0-57.676 32.045-57.676 71.436zm103.707-5.775h-91.944c2.241-30.323 21.977-54.113 45.914-54.113 23.996.001 43.782 23.79 46.03 54.113z",
    fill: "#D00000",
    "data-original": "#D00000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.203 289.865h213.35c3.188 0 5.774-2.586 5.774-5.774s-2.586-5.774-5.774-5.774h-213.35c-3.188 0-5.774 2.586-5.774 5.774 0 3.187 2.586 5.774 5.774 5.774z",
    fill: "#D00000",
    "data-original": "#D00000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.203 342.812h213.35c3.188 0 5.774-2.586 5.774-5.774s-2.586-5.774-5.774-5.774h-213.35c-3.188 0-5.774 2.586-5.774 5.774s2.586 5.774 5.774 5.774z",
    fill: "#D00000",
    "data-original": "#D00000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.778 384.218h-105.801c-3.188 0-5.774 2.586-5.774 5.774s2.586 5.774 5.774 5.774h105.801c3.188 0 5.774-2.586 5.774-5.774.001-3.187-2.586-5.774-5.774-5.774z",
    fill: "#D00000",
    "data-original": "#D00000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.485 48.12v415.76c0 20.165 16.406 36.571 36.571 36.571h287.643c20.165 0 36.571-16.406 36.571-36.571v-272.645c30.39-2.9 54.244-28.586 54.244-59.761 0-31.14-23.854-56.789-54.244-59.687v-23.667c0-20.165-16.406-36.571-36.571-36.571h-287.643c-20.165 0-36.571 16.406-36.571 36.571zm355.053 34.925c26.703 0 48.429 21.722 48.429 48.429 0 26.744-21.726 48.504-48.429 48.504-26.748 0-48.508-21.759-48.508-48.504 0-26.707 21.759-48.429 48.508-48.429zm-343.504-34.925c0-13.797 11.226-25.023 25.023-25.023h287.643c13.797 0 25.023 11.226 25.023 25.023v23.67c-30.396 2.931-54.241 28.569-54.241 59.683 0 31.15 23.844 56.822 54.241 59.758v272.649c0 13.797-11.226 25.023-25.023 25.023h-287.644c-13.797 0-25.023-11.226-25.023-25.023v-415.76z",
    fill: "#D00000",
    "data-original": "#D00000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.045 149.91c2.256 2.256 5.91 2.256 8.165 0l28.639-28.639c2.256-2.256 2.256-5.91 0-8.165-2.256-2.256-5.91-2.256-8.165 0l-24.556 24.556-7.816-7.812c-2.256-2.256-5.91-2.256-8.165 0-2.256 2.256-2.256 5.91 0 8.165z",
    fill: "#D00000",
    "data-original": "#D00000",
    className: ""
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration1);
export default __webpack_public_path__ + "static/media/registration1.aa91b93d991a8aa2bfe4325210ee1786.svg";
export { ForwardRef as ReactComponent };